export default __webpack_public_path__ + "static/025-a65bb962c7d26c1e8fdf7f6db7cbacc4.jpg";